import React , { useEffect } from 'react';
import Badge from '@mui/material/Badge';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { DayCalendarSkeleton } from '@mui/x-date-pickers/DayCalendarSkeleton';
import { GetSpecialDateTime, getTimeSlotSpecialDay } from '../service/utinity_service';
import dayjs from 'dayjs';
const initialValue = dayjs();

function ServerDay(props) {
  const { highlightedDays = [], day, outsideCurrentMonth, ...other } = props;
  const isSelected = !outsideCurrentMonth && highlightedDays.indexOf(day.format('YYYY-MM-DD')) >= 0;

  return (
    <Badge
      key={day.toString()}
      overlap="circular"
      badgeContent={isSelected ? '⭐' : undefined}
    >
      <PickersDay {...other} outsideCurrentMonth={outsideCurrentMonth} day={day} />
    </Badge>
  );
}

export default function DateCalendarServerRequest({ specialday, setState , setopen , setDefaultTimeSlots , data , setData ,datadefault }) {
  const [isLoading, setIsLoading] = React.useState(false);
  const [highlightedDays, setHighlightedDays] = React.useState([]);

  useEffect(() => {
    
  }, [data]);

  const handleGetSpecialDay = async (data) => {
    try {
      const res = await getTimeSlotSpecialDay(data);
      // setData(res);
      if(res.length > 0) {
        setData(res);
      }else{
        setData(datadefault);
      }
    } catch (error) {
      console.error("handleGetSpecialDay",error);
    }
  };

  const fetchHighlightedDays = React.useCallback(() => {
    if (specialday && specialday.length > 0) {
      const transformedDays = specialday.map((item) => {
        const [day, month, year] = item.date.split('-');
        return `${year}-${month}-${day}`;
      });
      setHighlightedDays(transformedDays);
    } else {
      setHighlightedDays([]);
    }
    setIsLoading(false);
  }, [specialday]);

  React.useEffect(() => {
    setIsLoading(true);
    fetchHighlightedDays();
  }, [fetchHighlightedDays]);

  const handleMonthChange = (date) => {
    setIsLoading(true);
    setHighlightedDays([]);
    fetchHighlightedDays();
  };

  // New handler for date selection
  const handleDateChange = (date) => {
    // // Log the selected date in different formats
    // console.log('Selected Date (ISO):', date.toISOString());
    // console.log('Selected Date (YYYY-MM-DD):', date.format('YYYY-MM-DD'));
    // console.log('Selected Date (DD-MM-YYYY):', date.format('DD-MM-YYYY'));
    setState(new Date(date))
    setopen(true);
    handleGetSpecialDay(date.format('DD-MM-YYYY'))
     
    // You can also handle the selected date here
    // For example, update state, call a parent component callback, etc.
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateCalendar
        defaultValue={initialValue}
        loading={isLoading}
        onMonthChange={handleMonthChange}
        onChange={handleDateChange} // Added onChange handler
        renderLoading={() => <DayCalendarSkeleton />}
        slots={{
          day: ServerDay,
        }}
        slotProps={{
          day: {
            highlightedDays,
          },
        }}
        disablePast
      />
    </LocalizationProvider>
  );
}